// convert destination name in url to two letter country code aka countryId in dato (i.e. 'north-wales' -> 'GB')
export const COUNTRY_IDS = {
  uk: 'GB',
  denmark: 'DK',
  sweden: 'SE',
  norway: 'NO',
  finland: 'FI',
  iceland: 'IS',
  france: 'FR',
  germany: 'DE',
  italy: 'IT',
  spain: 'ES',
  portugal: 'PT',
  netherlands: 'NL',
  belgium: 'BE',
  switzerland: 'CH',
  austria: 'AT',
  greece: 'GR',
  croatia: 'HR',
  ireland: 'IE',
  poland: 'PL',
  'czech-republic': 'CZ',
  hungary: 'HU',
  slovakia: 'SK',
  slovenia: 'SI',
  estonia: 'EE',
  latvia: 'LV',
  lithuania: 'LT',
  romania: 'RO',
  bulgaria: 'BG',
  serbia: 'RS',
  montenegro: 'ME',
  albania: 'AL',
  'north-macedonia': 'MK',
  'bosnia-herzegovina': 'BA',
  kosovo: 'XK',
  malta: 'MT',
  cyprus: 'CY',
  luxembourg: 'LU',
  liechtenstein: 'LI',
  monaco: 'MC',
  'san-marino': 'SM',
  'vatican-city': 'VA',
  andorra: 'AD',
  gibraltar: 'GI',
  'isle-of-man': 'IM',
  turkey: 'TR',
  morocco: 'MA',
  russia: 'RU',
  ukraine: 'UA',
  moldova: 'MD',
  belarus: 'BY',
  georgia: 'GE',
  armenia: 'AM',
  azerbaijan: 'AZ'
} as const;

type CountryId = (typeof COUNTRY_IDS)[keyof typeof COUNTRY_IDS];

export const getCountryIdFromDestinationInUrl = (countryName: string): CountryId | undefined => {
  if (!countryName || typeof countryName !== 'string') {
    return undefined;
  }

  // Normalize the country name (lowercase and replace spaces with hyphens)
  const normalizedCountryName = countryName.toLowerCase().replace(/\s+/g, '-');

  return COUNTRY_IDS[normalizedCountryName];
};
